import config from '@/config'

class LogService {
  static error (error: any) {
    if (config.activeLogs) {
      // eslint-disable-next-line
      console.error(error)
    }
  }
  static log (message: string) {
    if (config.activeLogs) {
      // eslint-disable-next-line
      console.log(message)
    }
  }
  static warn (error: any) {
    if (config.activeLogs) {
      // eslint-disable-next-line
      console.warn(error)
    }
  }
}

const ToString = function (object: any, identation: boolean = false): string {
  return identation ? JSON.stringify(object, null, 2) : JSON.stringify(object)
}

export default LogService
export { ToString }
